<template>
    <div class="d-flex row" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
        <div class="col-md-3">
        <UserSearchCard :searchByCliente="true" :showCreci="false" :searchCustomer="true" v-on:dataSearch="GetFilter" v-if="!isUserSelected"></UserSearchCard>
        <UserSummaryCard  :corretor="corretor" :showCreci="false" :showEnterprises="true" v-if="isUserSelected"  :entreprisesUserArray="entreprisesUserArray"  :userDataProp="editUser"></UserSummaryCard>
        </div>
        <div class="col-md-9 table-customers">
            <CustomerTable  ref="tableCustomers" :key="keyTableCustomers" v-on:inactivateUser="inactivateUser" v-on:deleteCustomer="deleteCustomer" v-on:selectUser="selectUser" v-if="!isUserSelected"></CustomerTable>
            <div v-if="isUserSelected" class="adm-view">
                <CustomerTabs :corretor="corretor" v-on:updateView="updateView" :entreprisesUserArray="entreprisesUserArray" :editUserData="editUser"></CustomerTabs>
            </div>
            <div v-if="!isUserSelected" class="container-modal">
                <UserAddModal :showCreci="false" :insertCustomer="true" :titleModal="'Adicionar novo Cliente'" v-on:updateTableCustomers="updateTableCustomers"></UserAddModal>
            </div>
        </div>
    </div>
</template>

<style scoped>

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.table-customers thead, .table-customers tbody{
  display: block;
}

.table-customers tbody{
  overflow-y: auto;
  height: 500px;
}

.table-customers th,
.table-customers td {
  width: 300px;
}

.text-third {
  font-size: 16px;
  font-weight: normal;
}
</style>

<script>
import CustomerBoard from './customers.js'
export default CustomerBoard
</script>



// WEBPACK FOOTER //
// src/views/private/realestate/users/customers.vue